/**
 * Dictionary of all routes in the application.
 * Should reflect the routing structure in {@link Routes} defined in Router.tsx
 */
export const Route = {
    Dashboard: '/',
    Projects: '/projects',
    Tasks: '/tasks',
    Project: (pid: string) => `/projects/${pid}` as const,
    ProjectTasks: (pid: string) => `/projects/${pid}/tasks` as const,
    ProjectPss: (pid: string) => `/projects/${pid}/pss` as const,
    ProjectVulnerabilitySecurityNotifications: (pid: string) =>
        `/projects/${pid}/vulnerability/security-notifications` as const,
    ProjectVulnerabilitySecurityNotificationsVulnerabilities: (pid: string) =>
        `/projects/${pid}/vulnerability/security-notifications/vulnerabilities` as const,
    ProjectVulnerabilityMeasures: (pid: string) =>
        `/projects/${pid}/vulnerability/measures` as const,
    ProjectMitigation: (pid: string) => `/projects/${pid}/mitigation` as const,
    ProjectMitigationEdit: (pid: string, mid: string) =>
        `/projects/${pid}/mitigation/edit/${mid}` as const,
    ProjectTra: (pid: string) => `/projects/${pid}/tra` as const,
    ProjectAssets: (pid: string) =>
        `/projects/${pid}/security-zones-assets` as const,
    ProjectAllRequirements: (pid: string) =>
        `/projects/${pid}/security-zones-assets/requirements` as const,
    ProjectZoneRequirementsAll: (pid: string, pzid: string) =>
        `/projects/${pid}/security-zones-assets/requirements/${pzid}` as const,
    ProjectZoneRequirements: (pid: string, pzid: string, spid: string) =>
        `/projects/${pid}/security-zones-assets/requirements/${pzid}/${spid}` as const,
    ProjectComponents: (pid: string) => `/projects/${pid}/components` as const,
    Standards: `/standards`,
    Standard: (sid: string) => `/standards/${sid}` as const,
    StandardRequirements: (sid: string) =>
        `/standards/${sid}/requirements` as const,
    StandardProfileRequirements: (sid: string, spid: string) =>
        `/standards/${sid}/${spid}/requirements` as const,
    ComponentLibrary: '/notification-components',
    SecurityNotifications: '/security-notifications',
    Admin: '/admin',
    AdminUsers: '/admin/users',
    AdminStandards: '/admin/standards',
    AdminRequirements: '/admin/requirements',
    AdminMappings: '/admin/mappings',
    AdminPss: '/admin/pss',
    Me: '/me',
    ProjectCra: (pid: string) => `/projects/${pid}/cra` as const,
    ProjectCraTopic: (pid: string, topic: string) =>
        `/projects/${pid}/cra/${topic}` as const,
} as const;
